<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <section class="donation-area pos-rel pt-100 grey-bg2 pb-100"
      style="background-image: url(assets/img/shape/01.png); background-size: cover; background-attachment: fixed;">
      <div class="container">
        <div class="row align-items-start justify-content-center">

          <div class="col-xl-5 col-lg-5 col-md-12 mb-40 order-lg-1 order-2">
            <div class="donation-wrapper sticky-top" style="top: 120px;">
              <div v-if="!pgLoading" class="section-title text-left wow fadeInUp2 animated" data-wow-delay=".1s">
                <h6 class="mb-3" style="color: #007bff;">
                  <span :style="[locale == 'en' ? { left: 'auto' } : {}]">
                    <i class="fas fa-hand-holding-seedling"></i>
                  </span>&nbsp;{{ info.title }}
                </h6>
                <p class="text-muted" style="line-height: 1.8;" v-html="info.body"></p>
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-7 col-md-12 order-lg-2 order-1">
            <div class="donation-form-container">

              <div class="donation-card mb-30 wow fadeInUp2 animated" data-wow-delay=".1s">
                <div class="text-center mb-3">
                  <h6 class="theme-color mb-2">
                    <i class="fas fa-hand-holding-seedling fa-flip-horizontal"></i> {{ info.title }}
                  </h6>
                  <h4 class="font-weight-bold">{{ $t("app.donation_values_types") }}</h4>
                </div>

                <div class="select-area mb-20">
                  <select class="form-control custom-select-box" v-model="type_id" @change="changeType(type_id)">
                    <option value="0" disabled>{{ $t("app.donation_types") }}</option>
                    <option v-for="(row, index) in types" :key="index" :value="row.id">
                      {{ row.name }}
                    </option>
                  </select>
                </div>

                <div class="amount-stepper-container mb-20">
                  <button class="stepper-btn" @click.prevent="decrementCustomAmount()">
                    <i :class="[locale == 'ar' ? 'far fa-chevron-right' : 'far fa-chevron-left']"></i>
                  </button>
                  <input type="number" min="1" class="stepper-input" v-model="custom_amount"
                    :placeholder="$t('app.enter_amount')" />
                  <button class="stepper-btn" @click.prevent="incrementCustomAmount()">
                    <i :class="[locale == 'ar' ? 'far fa-chevron-left' : 'far fa-chevron-right']"></i>
                  </button>
                </div>

                <div class="preset-amounts grid-amounts" v-if="!custom_amount.length">
                  <button v-for="(row, index) in values" :key="index" @click="changeAmount(row.id, row.amount)"
                    class="preset-btn" :class="amount_id == row.id ? 'active' : ''">
                    {{ row.amount }}
                    <span class="currency-label">{{ currency == "KWD" ? (locale == 'ar' ? "د.ك" : "KWD") : (locale ==
                      'ar' ? "ريال" : "SAR") }}</span>
                  </button>
                </div>
              </div>

              <div class="donation-card mb-30 wow fadeInUp2 animated" data-wow-delay=".2s">
                <div class="text-center mb-4">
                  <h4 class="font-weight-bold">{{ $t("cart.payment_method") }}</h4>
                </div>

                <div class="payment-methods-grid">
                  <div v-for="method in paymentMethods" :key="method.PaymentMethodId" class="payment-item-wrapper">
                    <input :id="'payment_d_' + method.PaymentMethodId" type="radio" :value="method.PaymentMethodId"
                      class="payment-radio-hidden" :checked="payment_method == method.PaymentMethodId"
                      @change="pamyentMethod(method.PaymentMethodId)" name="payment_method_d" />
                    <label class="payment-item-label" :for="'payment_d_' + method.PaymentMethodId">
                      <img :src="method.ImageUrl" :alt="method.PaymentMethodEn" class="payment-logo" loading="lazy" />
                      <span class="payment-method-name">
                        {{ $i18n.locale == "ar" ? method.PaymentMethodAr : method.PaymentMethodEn }}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="donation-card mb-30 wow fadeInUp2 animated" data-wow-delay=".3s">
                <div class="text-center mb-4">
                  <h4 class="font-weight-bold">{{ $t("cart.donation_info") }}</h4>
                </div>

                <ul class="nav nav-pills custom-pills justify-content-center mb-4" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="home-tab" data-toggle="pill" href="#home" role="tab"
                      aria-controls="home" aria-selected="true">{{ $t("cart.donation_info") }}</a>
                  </li>
                  <li class="nav-item mx-2">
                    <a class="nav-link" id="profile-tab" data-toggle="pill" href="#profile" role="tab"
                      aria-controls="profile" aria-selected="false">{{ $t("cart.good_man") }}</a>
                  </li>
                </ul>

                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                    <form @submit.prevent>
                      <div class="form-group mb-3">
                        <input type="text" class="form-control custom-input" v-model="row.name"
                          :placeholder="$t('contact.name')" />
                      </div>
                      <div class="form-group mb-3" dir="ltr">
                        <vue-tel-input class="form-control custom-input tel-override" v-model="row.mobile"
                          :placeholder="$t('contact.mobile')" :defaultCountry="'KW'"
                          v-on:country-changed="countryChanged" required maxlength="14" minlength="4"></vue-tel-input>
                      </div>
                      <div class="form-group mb-3">
                        <input type="email" class="form-control custom-input" v-model="row.email"
                          :placeholder="$t('contact.email')" />
                      </div>
                      <div class="form-group mb-4">
                        <textarea class="form-control custom-input" v-model="row.notes"
                          :placeholder="$t('contact.notes')" rows="2"></textarea>
                      </div>
                      <div class="custom-control custom-checkbox mb-4 d-flex align-items-center">
                        <input type="checkbox" class="custom-control-input" id="invoice" v-model="row.send_email"
                          :true-value="1" :false-value="0">
                        <label class="custom-control-label mx-2" style="cursor:pointer;" for="invoice">{{
                          $t("cart.want_email") }}</label>
                      </div>
                    </form>
                  </div>

                  <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                    <p class="text-center mb-3 text-muted">{{ $t("cart.good_man_detail") }}</p>
                    <div class="form-group mb-4" dir="ltr">
                      <vue-tel-input class="form-control custom-input tel-override" v-model="row.mobile"
                        :placeholder="$t('contact.mobile')" :defaultCountry="'KW'"
                        v-on:country-changed="countryChanged"></vue-tel-input>
                    </div>
                  </div>
                </div>

                <button class="btn custom-submit-btn w-100" @click="submit()" :disabled="btnLoading">
                  <span v-if="btnLoading" class="spinner-border spinner-border-sm mx-2" role="status"
                    aria-hidden="true"></span>
                  {{ $t("cart.pay_now") }}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { resolveDonorData } from "@/helpers/sendEvent";
import { trackCheckout } from "@/helpers/pixel";
import iziToast from "izitoast";
import { VueTelInput } from "vue-tel-input";
import { getPaymentMethods } from "@/data/paymentMethods";

export default {
  name: "Donation",
  components: {
    VueTelInput,
  },
  data() {
    return {
      auth: { access_token: "" },
      pgLoading: true,
      info: "",
      type_id: 0,
      amount_id: 1,
      amount: "",
      custom_amount: "",
      types: [],
      values: [],
      locale: "ar",
      currency: "KWD",
      paymentStatus: 1,
      row: {
        is_anonymous: 0,
        name: "",
        mobile: "",
        send_email: 0,
        email_address: "",
        is_paid: 0,
        payment_method: 1,
        notes: "",
        ccode: "",
      },
      payment_method: 1,
      paymentMethods: [],
      btnLoading: false,
    };
  },
  created() {
    if (localStorage.getItem("access_token")) this.auth.access_token = localStorage.getItem("access_token");
    if (localStorage.getItem("locale")) this.locale = localStorage.getItem("locale");
    if (localStorage.getItem("currency")) this.currency = localStorage.getItem("currency");

    this.fetchData();
    this.fetchPayment();
    this.fetchPaymentMethods();
  },
  methods: {
    async fetchPaymentMethods() {
      this.paymentMethods = await getPaymentMethods();
      if (this.paymentMethods.length > 0) {
        this.payment_method = this.paymentMethods[0].PaymentMethodId; // Default select first
      }
    },
    pamyentMethod(id) {
      this.payment_method = id;
    },
    countryChanged(country) {
      this.row.ccode = country.dialCode;
    },
    fetchPayment() {
      this.$axios.get(window.baseURL + "/settings/26")
        .then((res) => { this.paymentStatus = res.data.status; })
        .catch(() => { this.paymentStatus = 0; });
    },
    fetchData() {
      this.pgLoading = true;
      this.$axios.get(window.baseURL + "/settings/1", { params: { locale: this.locale } })
        .then((res) => {
          this.info = res.data.info;
          this.fetchDonationsValues();
        }).catch(() => { this.pgLoading = false; });
    },
    fetchDonationsValues() {
      this.$axios.get(window.baseURL + "/donations/values", { params: { locale: this.locale } })
        .then((res) => {
          this.values = res.data.rows;
          if (this.values.length > 0) {
            this.amount_id = this.values[0].id;
            this.amount = this.values[0].amount;
          }
          this.fetchDonationsTypes();
        }).catch(() => { this.pgLoading = false; });
    },
    fetchDonationsTypes() {
      this.$axios.get(window.baseURL + "/donations/types", { params: { locale: this.locale, currency: this.currency } })
        .then((res) => {
          this.pgLoading = false;
          this.types = res.data.rows;
          if (this.types.length > 0) {
            this.type_id = this.types[0].id;
          }
        }).catch(() => { this.pgLoading = false; });
    },
    incrementCustomAmount() {
      this.custom_amount = (parseInt(this.custom_amount) || 0) + 1;
    },
    decrementCustomAmount() {
      if (this.custom_amount > 1) {
        this.custom_amount = parseInt(this.custom_amount) - 1;
      }
    },
    submit() {
      if (this.paymentStatus == 0) {
        return iziToast.warning({ icon: "ti-alert", message: this.$t("app.payment_status_error") });
      }

      this.btnLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `Bearer ` + this.auth.access_token,
      };

      let amount_total = this.amount;
      if (Number(this.custom_amount) >= 1) {
        amount_total = this.custom_amount;
      }

      // If user is on the Anonymous tab, flag it
      const activeTab = document.querySelector('#profile-tab').classList.contains('active');
      const isAnon = activeTab ? 1 : this.row.is_anonymous;

      const donorEmail = (this.row.email || this.row.email_address || "").trim();
      const donorName = (this.row.name || "").trim();
      const donorMobile = (this.row.mobile || "").trim();
      const donorCcode = (this.row.ccode || "+965").trim();

      if (donorMobile) {
        localStorage.setItem("donor_mobile", donorMobile);
      }
      if (donorCcode) {
        localStorage.setItem("donor_ccode", donorCcode);
      }
      if (donorEmail && donorEmail.includes("@")) {
        localStorage.setItem("donor_email", donorEmail);
      }
      if (donorName) {
        localStorage.setItem("donor_name", donorName);
      }

      const donorInfo = {
        mobile: donorMobile,
        ccode: donorCcode,
        email: donorEmail,
        name: donorName,
      };

      const donorData = resolveDonorData(donorInfo);
      const totalAmount = Number(amount_total) >= 1 ? amount_total : 1;
      // trackCheckout fires both browser pixel (InitiateCheckout + AddPaymentInfo)
      // AND CAPI for both — no need for a separate sendEvent call.
      const checkoutData = trackCheckout(
        {
          value: totalAmount,
          currency: "KWD",
          content_ids: this.type_id ? [this.type_id] : [],
          content_name: this.info ? this.info.title : "General Donation",
          content_type: "general_donation",
          num_items: 1,
          payment_method: this.payment_method,
        },
        { ...donorData }
      );
      // Use the event_id generated by trackCheckout for the API submission
      const initEventId = checkoutData._eventId || donorData.external_id || null;

      const options = {
        url: window.baseURL + "/donations",
        method: "POST",
        data: {
          is_anonymous: isAnon,
          name: donorData.name,
          first_name: donorData.first_name,
          last_name: donorData.last_name,
          mobile: donorData.mobile,
          ccode: donorData.ccode,
          send_email: this.row.send_email,
          email_address: donorData.email,
          email: donorData.email,
          is_paid: this.row.is_paid,
          payment_method: this.payment_method,
          total: totalAmount,
          itemName: this.info ? this.info.title : "General Donation",
          currency: "KWD",
          notes: this.row.notes,
          type_id: this.type_id,

          event_id: initEventId,
          fbc: donorData.fbc,
          fbp: donorData.fbp,
          external_id: donorData.external_id,
        },
      };

      this.$axios(options)
        .then((res) => {
          this.btnLoading = false;
          if (res.data.link) {
            setTimeout(() => {
              window.open(res.data.link, "_self");
            }, 250);
          } else {
            iziToast.warning({ icon: "ti-alert", message: res.response ? this.$t("app.error_contact_us") : "" + res });
          }
        })
        .catch((err) => {
          this.btnLoading = false;
          if (err.response && err.response.status == 401) {
            this.removeLocalStorage();
            this.$router.push({ name: "login" });
          } else {
            iziToast.warning({ icon: "ti-alert", message: err.response ? this.$t("app.error_contact_us") : "" + err });
          }
        });
    },
    removeLocalStorage() {
      ['access_token', 'user_image', 'first_name', 'last_name', 'user_id', 'email', 'id_number'].forEach(k => localStorage.removeItem(k));
    },
    changeAmount: function (id, amount) {
      this.amount = amount;
      this.amount_id = id;
      this.custom_amount = "";
    },
    changeType: function (id) {
      this.type_id = id;
    },
  },
};
</script>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>

<style scoped>
/* Main Layout styling */
.theme-color {
  color: #e91e63;
  /* Adjust to match the pink logo color */
}

/* Floating Cards matching image */
.donation-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 35px 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;
}

/* Amount Stepper matching < 500 > from screenshot */
.amount-stepper-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  height: 55px;
}

.stepper-btn {
  background: transparent;
  border: none;
  width: 50px;
  height: 100%;
  color: #888;
  font-size: 14px;
  transition: background 0.2s;
}

.stepper-btn:hover {
  background: #f5f5f5;
  color: #333;
}

.stepper-input {
  border: none;
  text-align: center;
  width: 100%;
  font-size: 18px;
  font-weight: 600;
  outline: none;
  -moz-appearance: textfield;
}

.stepper-input::-webkit-outer-spin-button,
.stepper-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Preset Buttons Grid */
.grid-amounts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 10px;
}

.preset-btn {
  border: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 8px;
  padding: 12px 5px;
  font-weight: 600;
  transition: all 0.2s;
}

.preset-btn:hover {
  border-color: #e91e63;
  color: #e91e63;
}

.preset-btn.active {
  background: #e91e63;
  color: #fff;
  border-color: #e91e63;
}

.currency-label {
  font-size: 12px;
  margin: 0 2px;
}

/* Payment Methods CSS Grid */
.payment-methods-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.payment-radio-hidden {
  display: none;
}

.payment-item-label {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 15px 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  /* Stack logo and text vertically */
  align-items: center;
  justify-content: center;
  min-height: 90px;
  /* Increased height to fit text nicely */
  transition: all 0.2s ease-in-out;
  margin: 0;
}

.payment-logo {
  max-width: 100%;
  max-height: 35px;
  object-fit: contain;
  margin-bottom: 8px;
}

.payment-method-name {
  font-size: 12px;
  color: #666;
  text-align: center;
  line-height: 1.2;
}

/* Pink border highlight when selected */
.payment-radio-hidden:checked+.payment-item-label {
  border: 2px solid #e91e63;
  background-color: #fdf2f6;
}

/* Custom Standard Inputs */
.custom-input,
.custom-select-box {
  height: 55px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: none;
}

.custom-input:focus,
.custom-select-box:focus {
  border-color: #e91e63;
  box-shadow: 0 0 0 0.2rem rgba(233, 30, 99, 0.1);
}

/* Tabs overriding to look like Pills in image */
.custom-pills .nav-link {
  border-radius: 30px;
  color: #666;
  padding: 8px 25px;
  font-weight: 600;
}

.custom-pills .nav-link.active {
  background-color: #f5f5f5;
  color: #e91e63;
}

.custom-pills .nav-link::before,
.custom-pills .nav-link::after {
  display: none !important;
  /* hide default pseudo elements if any inherited */
}

/* Tel Input Override */
.tel-override {
  padding: 0;
}

.tel-override :deep(.vti__input) {
  border-radius: 8px;
}

.tel-override :deep(.vti__dropdown) {
  padding: 10px;
}

/* Submit Button */
.custom-submit-btn {
  background-color: #e91e63;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  height: 60px;
  border-radius: 8px;
  transition: 0.3s;
}

.custom-submit-btn:hover {
  background-color: #d81557;
  color: white;
}

/* Responsive styling */
@media (max-width: 768px) {
  .payment-methods-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .donation-card {
    padding: 25px 20px;
  }
}
</style>